module.exports = __webpack_public_path__ + "img/step_1-1.a4eb9bba.png";